import apiClient from './apiService';

export type ImplementationType = 'SOP' | 'IT_APPLICATION' | 'IT_ASSET';

export interface ImplementationStep {
  id: number;
  entity_id: number;
  control_id: number;
  sequence_number: number;
  implementation_type: ImplementationType;
  target_id: number;
  target_label?: string | null;
  target_subtitle?: string | null;
  explanation?: string | null;
  is_active: number;
  created_by?: number | null;
  created_on?: string;
  modified_by?: number | null;
  modified_on?: string;
}

export interface CreateImplPayload {
  implementation_type: ImplementationType;
  target_id: number;
  explanation?: string;
  sequence_number?: number;
}

export interface UpdateImplPayload {
  implementation_type?: ImplementationType;
  target_id?: number;
  explanation?: string;
  sequence_number?: number;
  is_active?: number;
}

export const controlImplementationsService = {
  async list(controlId: number): Promise<ImplementationStep[]> {
    const r = await apiClient.get(`/api/v1/ctr/controls/${controlId}/implementations`);
    return r.data?.data ?? [];
  },
  async create(controlId: number, payload: CreateImplPayload): Promise<ImplementationStep> {
    const r = await apiClient.post(`/api/v1/ctr/controls/${controlId}/implementations`, payload);
    return r.data?.data;
  },
  async update(controlId: number, stepId: number, payload: UpdateImplPayload): Promise<ImplementationStep> {
    const r = await apiClient.put(`/api/v1/ctr/controls/${controlId}/implementations/${stepId}`, payload);
    return r.data?.data;
  },
  async remove(controlId: number, stepId: number): Promise<void> {
    await apiClient.delete(`/api/v1/ctr/controls/${controlId}/implementations/${stepId}`);
  },
  async move(controlId: number, stepId: number, direction: 'UP' | 'DOWN'): Promise<void> {
    await apiClient.post(`/api/v1/ctr/controls/${controlId}/implementations/${stepId}/reorder`, { direction });
  },
};

export default controlImplementationsService;
